// import {
//     temAcesso
// } from '@/shared/auth/temAcesso'
import contratacoesRotas from './contratacoes/ContratacoesRotas'
import entregasRotas from './entregas/EntregasRotas'

export default {
    path: 'apoios',
    name: 'Apoios',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    // beforeEnter: (to, from, next) => {
    //     if (to.name === 'Gestores') {
    //         if (temAcesso('GEST-00')) {
    //             next()
    //         }
    //     } else {
    //         next()
    //     }
    // },
    children: [contratacoesRotas, entregasRotas]
}
